import DealsTable from './DealsTable/DealsTable';
import Filters from './Filters/Filters';
import { useOOCReport } from './OOCReport/useOOCReport';

const DirectSalesDeals: React.FC = () => {
  useOOCReport();

  return (
    <div className="py-4 px-14 h-[calc(100%-3.75rem)] flex flex-col">
      <Filters />
      <div className="mt-4 flex-1 min-h-0">
        <DealsTable />
      </div>
    </div>
  );
};

export default DirectSalesDeals;
